/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-30 16:53:17
 * @LastEditors: K
 * @LastEditTime: 2022-09-01 17:09:24
 */
import { Col, Form, Input, Modal, Popover, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../app/store';
import styles from "./labelManagementPage.module.css";
interface LabelModalProps {
  visible: boolean
  editData: any
  onOk: (obj: any) => void
  onCancel: () => void
}
export const LabelModal = ({
  visible,
  editData,
  onOk,
  onCancel,
}: LabelModalProps): ReactElement => {

  const [form] = Form.useForm();

  const [btnLoading, setBtnLoading] = useState(false);

  useEffect(() => {
    console.log(editData, 'editData');

    form.resetFields();
    visible && setBtnLoading(false)
    editData?.id && form.setFieldsValue({
      ...editData
    })

  }, [visible])



  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  const colorList = [
    {
      index: 0,
      backgorundColor: "#f80e0e",
      text: "上",
      fontColor: "#FFFFFF",
    },
    {
      index: 1,
      backgorundColor: "#AD7CF0",
      text: "推",
      fontColor: "#FFFFFF",
    },
    {
      index: 2,
      backgorundColor: "#55E089",
      text: "高",
      fontColor: "#FFFEFE",
    },

    {
      index: 3,
      backgorundColor: "#FF96AF",
      text: "按",
      fontColor: "#FFFFFF",
    },
    {
      index: 4,
      backgorundColor: "#FFB54B",
      text: "妇",
      fontColor: "#FFFFFF",
    },
    {
      index: 5,
      backgorundColor: "#3FD4DD",
      text: "特",
      fontColor: "#FFFFFF",
    },
  ];
  return (
    <Modal
      cancelText="取消"
      okText="确定"
      destroyOnClose
      onCancel={() => {

        onCancel()
      }}
      onOk={() => {
        form.validateFields().then(res => {

          setBtnLoading(true)
          onOk({
            ...res,
            id: editData?.id
          })
        })

      }}
      visible={visible}
      confirmLoading={btnLoading}
      title={(editData?.id ? '编辑' : '新增') + "患者标签"}
      width="450px"
    >
      <Form
        form={form}
        initialValues={{
          backgroundColor: "#f80e0e",
          fontColor: "#FFFFFF",
        }}
        onValuesChange={(values) => {
          const back = values.backgroundColor;
          const color = values.fontColor
          const tag: any = document.getElementById("inputs")
          tag.style.background = back
          tag.style.color = color
        }}

        name="advanced_search"
        className="ant-advanced-search-form"
        {...layout}
      >
        <Row gutter={20}>
          <Col span={20} style={{ textAlign: "right" }}>
            <Form.Item
              label="名称"
              name="name"
              rules={[{ required: true, message: "名称不能为空!" }, { max: 40, message: "最大长度40" }]}

            >
              <Input autoComplete="off"
                onChange={(e) => {
                  form.setFieldsValue({
                    headName: (e.target.value).substring(0, 1),
                  });
                }} />
            </Form.Item>
          </Col>
          <Col span={20} style={{ textAlign: "right" }}>
            <Form.Item
              label="推荐颜色"
              name="backgroundColor"
              style={{ display: "flex" }}

            >
              <div style={{ display: "flex" }}>
                {colorList.map((v: any, i) => (
                  <div key={v.index} style={{ display: "flex" }}>
                    <div
                      onClick={() => {
                        const back = v.backgorundColor;
                        const color = v.fontColor
                        const tag: any = document.getElementById("inputs")
                        const inputs: any = document.getElementById("colors")
                        const input: any = document.getElementById("colord")
                        tag.style.background = back
                        tag.style.color = color
                        inputs.value = color
                        input.value = back
                        form.setFieldsValue({
                          backgroundColor: back,
                          fontColor: color,
                          range: '0'
                        });
                      }
                      }
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        textAlign: "center",
                        lineHeight: "30px",
                        color: "#FFFFFF",
                        backgroundColor: v.backgorundColor,
                        marginRight: "7px",
                      }}
                    >
                      {v.text}
                    </div>
                  </div>
                ))}
              </div>
            </Form.Item>
          </Col>
          <Col span={20} style={{ textAlign: "right" }}>
            <Form.Item label="缩写:" name="headName" rules={[{ required: true, message: "缩写不能为空!" }, { max: 1, message: "最多可输入一个字符" }]}>
              <Input autoComplete="off" disabled />

            </Form.Item>
          </Col>
          <Col span={20} style={{ textAlign: "right" }}>
            <Popover content={<div><p style={{ marginBottom: 0 }}>请选择字体颜色</p></div>} trigger="hover" placement="right">
              <Form.Item label="字体颜色" name="fontColor" rules={[{ max: 45, message: "最大长度45" }]}>
                <Input
                  id="colors"
                  type="color"
                  autoComplete="off"

                  style={{ paddingLeft: "190px", paddingRight: "-40px" }}

                />
              </Form.Item>
            </Popover>
          </Col>
          <Col span={20} style={{ textAlign: "right" }}>
            <Popover
              content={<div><p style={{ marginBottom: 0 }}>请选择背景颜色</p></div>}
              trigger="hover"
              placement="right"
              style={{ height: "10px", padding: 0 }}
            >
              <Form.Item label="背景颜色" name="backgroundColor" rules={[{ max: 45, message: "最大长度45" }]}>
                <Input id="colord" type="color" style={{ padding: 0 }} autoComplete="off" />
              </Form.Item>
            </Popover>
          </Col>

          <Col span={6} style={{ textAlign: "right", marginLeft: "60px" }}>

            <Form.Item label="预览:" name="headName" >
              <Input id="inputs" className={styles.inputs} style={{ width: "38px", height: "38px", borderRadius: "50%", lineHeight: '38px', textAlign: 'center', background: "#f80e0e", color: "#FFFFFF" }} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

